import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { MouseEventHandler } from "react";
import { useAppSelector } from "app/hooks";
import {
  selectCurrentRegion,
  selectCurrentClinic,
} from "features/auth/auth-slice";
import Stack from "@mui/material/Stack";

const RegionsSelectorHeader: React.FC<{
  minimalView?: boolean;
  regionsLength: number;
  handleClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ minimalView, regionsLength, handleClick }) => {
  const currentClinic = useAppSelector(selectCurrentClinic);
  const currentRegion = useAppSelector(selectCurrentRegion);

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      gap={0.5}
    >
      {!minimalView && (
        <Stack gap={0}>
          <Typography
            variant="body1"
            color="textPrimary"
            fontWeight="700"
            sx={{ fontSize: "12px", lineHeight: 1.2 }}
          >
            {currentRegion?.name}
          </Typography>
          <Typography
            variant="body1"
            color="textPrimary"
            fontWeight="700"
            sx={{ fontSize: "12px" }}
          >
            {currentClinic?.name}
          </Typography>
        </Stack>
      )}
      {regionsLength > 0 && (
        <IconButton
          data-testid="clinics-selector"
          onClick={handleClick}
          sx={{ p: 0.25 }}
        >
          <ArrowDropDownIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default RegionsSelectorHeader;
